<template>
  <div class="contentabout">
    <div class="container">
      <div class="row m-auto">
        <div class="about-card col-md-6" v-for="(item, key) in contents" :key="key">
          <quarter :quaterContent="item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import quarter from '@/components/grayNumber_one.vue';

export default {
  props: {
    quaterContent: {
      type: Array,
      default: () => ([
        {
          number: '01.',
          topic: '監測',
          txt:
            '田間氣象監測，是給予農民安心的保證。我們期許成為田間的守護者，幫忙像擔心孩子受餓著冷父母般的農民，透過氣象數據蒐集，將科學術語轉換成親切問候，在日常中提醒您在田間的作物生長環境變化，就像稻草人，靜靜地在農田中做好守護者的角色。',
        },
        {
          number: '02.',
          topic: '預測',
          txt:
            '田間氣象監測，是給予農民安心的保證。我們期許成為田間的守護者，幫忙像擔心孩子受餓著冷父母般的農民，透過氣象數據蒐集，將科學術語轉換成親切問候，在日常中提醒您在田間的作物生長環境變化，就像稻草人，靜靜地在農田中做好守護者的角色。',
        },
      ]),
    },
  },
  data() {
    return {
      contents: this.quaterContent,
    };
  },
  components: {
    quarter,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.contentabout {
  padding: 50px 0 10px 0;
}
@media screen and (max-width: 600px){
  .contentabout {
    .about-card{
      padding: 0;
    }
  }
}
</style>
